import { schema } from 'normalizr'

export const ENTITY_PRICEBOOK_INDUSTRIES = 'priceBookIndustries'
export const ENTITY_PRICEBOOK_INDUSTRIES_LIST = 'priceBookIndustriesList'

export const ENTITY_PRICING_CONTENT_BOOKS = 'pricingContentBooks'
export const ENTITY_PRICING_CONTENT_BOOKS_LIST = 'pricingContentBooksList'

export const ENTITY_PRICING_CONTENT_BOOKS_WITH_STATUS = 'pricingContentBooksWithStatus'
export const ENTITY_PRICING_CONTENT_BOOKS_WITH_STATUS_LIST = 'pricingContentBooksWithStatusList'

export const priceBookIndustriesSchema = new schema.Entity(
  ENTITY_PRICEBOOK_INDUSTRIES,
  {},
  { idAttribute: 'uuid' }
)
export const priceBookIndustriesListSchema = new schema.Entity(
  ENTITY_PRICEBOOK_INDUSTRIES_LIST,
  { data: [priceBookIndustriesSchema] },
  { idAttribute: () => 'list' }
)

export const pricingContentBooksSchema = new schema.Entity(
  ENTITY_PRICING_CONTENT_BOOKS,
  {},
  { idAttribute: 'uuid' }
)
export const pricingContentBooksListSchema = new schema.Entity(
  ENTITY_PRICING_CONTENT_BOOKS_LIST,
  { data: [pricingContentBooksSchema] },
  { idAttribute: () => 'list' }
)

export const pricingContentBooksWithStatusSchema = new schema.Entity(
  ENTITY_PRICING_CONTENT_BOOKS_WITH_STATUS,
  {},
  { idAttribute: 'book_uuid' }
)
export const pricingContentBooksWithStatusListSchema = new schema.Entity(
  ENTITY_PRICING_CONTENT_BOOKS_WITH_STATUS_LIST,
  { data: [pricingContentBooksWithStatusSchema] },
  { idAttribute: () => 'list' }
)

export const ENTITY_PRICEBOOK_CATEGORIES = 'priceBookCategories'
export const ENTITY_PRICEBOOK_CATEGORIES_LIST = 'priceBookCategoriesList'

export const priceBookCategoriesSchema = new schema.Entity(
  ENTITY_PRICEBOOK_CATEGORIES,
  {},
  { idAttribute: 'uuid' }
)

export const priceBookCategoriesListSchema = new schema.Entity(
  ENTITY_PRICEBOOK_CATEGORIES_LIST,
  { data: [priceBookCategoriesSchema] },
)

export const ENTITY_PRICEBOOK_SERVICES = 'priceBookServices'
export const ENTITY_PRICEBOOK_SERVICES_LIST = 'priceBookServicesList'

export const priceBookServicesSchema = new schema.Entity(
  ENTITY_PRICEBOOK_SERVICES,
  {},
  { idAttribute: 'uuid' }
)

export const priceBookServicesListSchema = new schema.Entity(
  ENTITY_PRICEBOOK_SERVICES_LIST,
  { data: [priceBookServicesSchema] },
)

export const ENTITY_PRICEBOOK_MATERIALS = 'priceBookMaterials'
export const ENTITY_PRICEBOOK_MATERIALS_LIST = 'priceBookMaterialsList'

export const priceBookMaterialsSchema = new schema.Entity(
  ENTITY_PRICEBOOK_MATERIALS,
  {},
  { idAttribute: 'uuid' }
)

export const priceBookMaterialsListSchema = new schema.Entity(
  ENTITY_PRICEBOOK_MATERIALS_LIST,
  { data: [priceBookMaterialsSchema] },
)

export const ENTITY_MATERIAL_CATEGORIES = 'materialCategories'
export const ENTITY_MATERIAL_CATEGORIES_LIST = 'materialCategoriesList'

export const materialCategoriesSchema = new schema.Entity(
  ENTITY_MATERIAL_CATEGORIES,
  {},
  { idAttribute: 'uuid' },
)

export const materialCategoriesListSchema = new schema.Entity(
  ENTITY_MATERIAL_CATEGORIES_LIST,
  { data: [materialCategoriesSchema] },
)

export const ENTITY_MATERIAL_BREADCRUMBS = 'materialsBreadCrumb';
export const ENTITY_MATERIAL_BREADCRUMBS_LIST = 'materialsBreadCrumbList';

export const materialBreadcrumbSchema = new schema.Entity(
  ENTITY_MATERIAL_BREADCRUMBS,
);

export const materialBreadcrumbSchemaList = new schema.Entity(
  ENTITY_MATERIAL_BREADCRUMBS_LIST,
  { data: [materialBreadcrumbSchema] },
  { idAttribute: () => 'bread_crumb_info' },
);

export const ENTITY_TAX_RATES = 'taxRates';
export const ENTITY_TAX_RATES_LIST = 'taxRatesList';

export const taxRateSchema = new schema.Entity(ENTITY_TAX_RATES, {}, { idAttribute: 'uuid' });
export const taxRateSchemaList = new schema.Entity(
  ENTITY_TAX_RATES_LIST,
  { data: [taxRateSchema] },
  { idAttribute: () => 'list' },
);

export const ENTITY_LABOR_RATES = 'laborRates';
export const ENTITY_LABOR_RATES_LIST = 'laborRatesList';

export const laborRateSchema = new schema.Entity(ENTITY_LABOR_RATES, {}, { idAttribute: 'uuid' });
export const laborRateSchemaList = new schema.Entity(
  ENTITY_LABOR_RATES_LIST,
  { data: [laborRateSchema] },
  { idAttribute: () => 'list' }
);

export const ENTITY_MATERIAL_MARKUPS = 'materialMarkups';
export const ENTITY_MATERIAL_MARKUPS_LIST = 'materialMarkupsList';

export const materialMarkupSchema = new schema.Entity(ENTITY_MATERIAL_MARKUPS, {}, { idAttribute: 'uuid' });
export const materialMarkupSchemaList = new schema.Entity(
  ENTITY_MATERIAL_MARKUPS_LIST,
  { data: [materialMarkupSchema] },
  { idAttribute: () => 'list' }
);

export const ENTITY_PRICING_CONTENT_UPDATES_VIEWED = 'pricingContentUpdatesViewed';

export const pricingContentUpdatesViewedSchema = new schema.Entity(ENTITY_PRICING_CONTENT_UPDATES_VIEWED, {}, { idAttribute: () => 'versions' });
